import React from "react";
import PropTypes from "prop-types";
import { useLocation, Link } from "react-router-dom";

export function PreservedLink({ to, ...props }) {
  const location = useLocation();
  const currentParams = new URLSearchParams(location.search);
  const preservedParams = new URLSearchParams();

  // Preserve ?ref= if present
  const ref = currentParams.get("ref");
  if (ref) preservedParams.set("ref", ref);

  // Preserve ?promo= if present
  const promo = currentParams.get("promo");
  if (promo) preservedParams.set("promo", promo);

  // Detect /partners/:code
  const pathMatch = location.pathname.match(/\/partners\/([^/?#]+)/);
  const preservedPathSegment = pathMatch ? `/partners/${pathMatch[1]}` : "";

  // Deconstruct input 'to' prop
  let pathname = typeof to === "string" ? to : to.pathname || "";
  let query = typeof to === "string" ? "" : to.search || "";
  let hash = "";

  // Handle hashes like "/page#section"
  if (pathname.includes("#")) {
    [pathname, hash] = pathname.split("#");
    hash = `#${hash}`;
  }

  const [basePath, existingQuery] = pathname.split("?");
  const finalParams = new URLSearchParams(existingQuery || query);

  // Merge preserved query
  preservedParams.forEach((value, key) => {
    if (!finalParams.has(key)) finalParams.set(key, value);
  });

  // Inject affiliate path segment if not already present
  let finalBasePath = basePath;
  if (preservedPathSegment && !basePath.includes("/partners/")) {
    finalBasePath = `${basePath.replace(/\/+$/, "")}${preservedPathSegment}`;
  }

  const finalQuery = finalParams.toString();
  const finalTo = `${finalBasePath}${finalQuery ? `?${finalQuery}` : ""}${hash}`;

  return <Link to={finalTo} {...props} />;
}

PreservedLink.propTypes = {
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string
    })
  ]).isRequired
};
